var React = require('react');

function CursorRightArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24.8155","cy":"24.8155","r":"24.0655","stroke":"#E0C6AD","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M17.0605 24.8154H32.5703","stroke":"#E0C6AD","strokeWidth":"1.5","key":1}),React.createElement("path",{"d":"M35.1553 24.8145L29.9854 29.4303V20.1987L35.1553 24.8145Z","fill":"#E0C6AD","key":2})]);
}

CursorRightArrow.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = CursorRightArrow;

CursorRightArrow.default = CursorRightArrow;
